module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-kpito-intro-card1.1.d00f30bd.jpg";